import React from 'react';
import MenuDishView from './MenuDishView';
import { calcAvgDishPrice } from '../../helpers/util';
import { maskMoney } from '../../masks';

class MenuCourseView extends React.Component {
  render() {
    const { course } = this.props;
    return (
      <div className="course cms__section">
        <div className="cms__section-body">
          <div className="cms__details-bar-item">
            <h4 className="h4">{course.name}</h4>
            <p className="p">{course.description}</p>
          </div>
          <table className="table">
            <thead className="table__thead table__thead--underline">
              <tr>
                <th className="table__th table__th--black">
                  <p className="p p--bold">Dish Name</p>
                </th>
                <th className="table__th table__th--black">
                  <p className="p p--bold">Ingredients</p>
                </th>
                <th className="table__th table__th--black">
                  <p className="p p--bold">Price (sm)</p>
                </th>
                <th className="table__th table__th--black">
                  <p className="p p--bold">Diet</p>
                </th>
                <th className="table__th table__th--black">
                  <p className="p p--bold">Allergens</p>
                </th>
                <th className="table__th table__th--black">
                  <p className="p p--bold">Complexity</p>
                </th>
              </tr>
            </thead>
            <tbody>{this.renderDishes(course.dishes)}</tbody>
          </table>
          <div className="table__th">
            <p className="p p--bold">
              Average Dish Price:{' '}
              <span className="p p--green">
                {maskMoney(calcAvgDishPrice(course.dishes))}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderDishes(dishes) {
    if (dishes && dishes.length > 0)
      return dishes.map((dish, i) => <MenuDishView key={i} dish={dish} />);
  }
}

export default MenuCourseView;



// WEBPACK FOOTER //
// ./src/components/menu/MenuCourseView.js